import Vacancy from './Vacancy';

export default Vacancy;
